import {
  CommentPresenterModel,
  MentionNode,
  RefProperty,
} from '@osos/shared/types';

// tslint:disable-next-line: no-namespace
export namespace CommentActions {
  export class CreateComment {
    static readonly type = '[COMMENT_STATE] Create Comment';
    constructor(
      public entityId: string,
      public entryId: string,
      public comment: Pick<
        CommentPresenterModel,
        'commentText' | 'attachments'
      > & {
        audience: Array<RefProperty>;
      },
    ) {}
  }

  export class UpdateComment {
    static readonly type = '[COMMENT_STATE] Update Comment';
    constructor(
      public entityId: string,
      public entryId: string,
      public commentId: string,
      public comment: {
        audience: Array<RefProperty>;
      },
    ) {}
  }

  export class FetchComments {
    static readonly type = '[COMMENT_STATE] Fetch Comments';
    constructor(
      public entityId: string,
      public entryId: string,
    ) {}
  }

  export class TransitoryFetchMentionList {
    static readonly type = '[COMMENT_STATE] Fetch Mention List';
    constructor(
      public payload: {
        searchTerm: string;
        entityId: string;
        entryId: string;
      },
    ) {}
  }

  export class UpdateLastCreatedCommentMeta {
    static readonly type = '[COMMENT_STATE] Update Last Created Comment Meta';
    constructor(
      public payload: {
        mentions: MentionNode[];
      },
    ) {}
  }
}
